import Im from "immutable";
import React from "react";
import { Tooltip } from "react-tippy";

import { BSBtnDropdown } from "traec-react/utils/bootstrap";
import { ErrorBoundary } from "storybook-dashboard/errors";

export const TableRow = (props) => {
  let { data, updateHandler } = props;

  return (
    <AddRowForm
      values={data}
      onChangeHandler={(e) => {
        updateHandler(data.merge({ [e.target.name]: e.target.value }));
      }}
      {...props}
    />
  );
};

export const AddRowForm = (props) => {
  let { fields, errors, removeHandler, copyHandler, values, readOnly } = props;
  return (
    <ErrorBoundary>
      <tr style={{ marginTop: "1px solid black" }} className={`${errors?.size > 0 ? "alert-warning" : ""}`}>
        {fields?.map((field, i) => (
          <FormCellInput key={i} field={field} {...props} />
        ))}
        <td>
          {!readOnly && (
            <BSBtnDropdown
              header={" "}
              floatStyle={" "}
              links={[
                { name: "Copy", onClick: (e) => copyHandler(values) },
                { name: "Delete", onClick: removeHandler },
              ]}
            />
          )}
        </td>
      </tr>
    </ErrorBoundary>
  );
};

const FormCellInput = (props) => {
  let { field, values, errors, onChangeHandler, readOnly } = props;
  let header = field.get("header");
  let fieldType = field.get("type");
  let error = errors?.get(header);
  let value = values.get(header);

  if (fieldType === "selection") {
    return <FormCellDropdown {...props} />;
  }

  return (
    <td className="">
      <Tooltip html={error} disabled={error ? false : true} animateFill={false} position={"right-start"}>
        {fieldType === "textarea" ? (
          <textarea
            disabled={readOnly}
            rows={"1"}
            type="text"
            className={`form-control form-control-sm ${error ? "is-invalid" : ""}`}
            id={header}
            name={header}
            value={value}
            onChange={onChangeHandler}
          />
        ) : (
          <input
            disabled={readOnly}
            type="text"
            placeholder={`${fieldType === "date" ? "dd/mm/yyyy" : ""}`}
            className={`form-control form-control-sm ${error ? "is-invalid" : ""}`}
            id={header}
            name={header}
            value={value}
            onChange={onChangeHandler}
          />
        )}
      </Tooltip>
    </td>
  );
};

export const _trim = (v) => {
  try {
    return v?.trim();
  } catch (e) {
    return v; // If trim fails, just return the value as is
  }
};

export const optionsMapToList = (options, values) => {
  if (!Im.Map.isMap(options)) return options;
  let dependentFields = Im.List(options.keys());
  let optionSet = dependentFields.reduce((a, dependentField) => {
    let dependentValue = values.get(dependentField);
    return a.union(options?.getIn([dependentField, dependentValue]) || Im.List());
  }, Im.Set());
  return Im.List(optionSet);
};

const FormCellDropdown = (props) => {
  let { field, values, errors, onChangeHandler, readOnly } = props;
  let header = field.get("header");
  let error = errors.get(header);
  let value = values.get(header);

  // If the options is a dictionary then options depends on other fields
  let options = optionsMapToList(field.get("options") || Im.List(), values);

  console.log("FormCellDropdown", header, value, options.toJS());

  let _options = options
    .unshift(null)
    .map((o) => _trim(o)) // Trim whitespace from options
    .map((option, i) => (
      <option key={i} value={option}>
        {option}
      </option>
    ));

  if (error == "Please select one of the choices available") {
    // If the error is about selection, we want to show the current value as an option
    _options = _options.push(
      <option key="current" value={value}>
        {value}
      </option>
    );
  }

  return (
    <td>
      <Tooltip html={error} disabled={error ? false : true} animateFill={false}>
        <select
          disabled={readOnly}
          type="text"
          className={`form-control form-control-sm ${error ? "is-invalid" : ""}`}
          id={header}
          name={header}
          value={value}
          onChange={onChangeHandler}
        >
          {_options}
        </select>
      </Tooltip>
    </td>
  );
};
